module.exports = __webpack_public_path__ + "static/media/gymet_4.d4543ca8.png";